module.exports = __webpack_public_path__ + "static/img/sofiaLogo.c8d4b32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/sofiaLogo.png
// module id = 4GHr
// module chunks = 1